import { ProblemResponibleType, ProblemType, ResponsibleProvider, ProblemReportFilter, SetProblemReportMeasure, ProblemReportMeasure } from './../webApi/DataModels'
import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '@/webApi'
import constants from '@/constants'
import Vue from 'vue'
import { map } from 'lodash'
class ProblemReportState {
  responsibleTypeOptions: any[] = []
  problemTypeOptions:any[] = []
  responsibleProvidersOptions:any[] = []
  loadedProblemReports:any[] = []
  measureOptions:any[] = []
  measureFilter:ProblemReportFilter
}
const mutations = <MutationTree<ProblemReportState>>{
  setResponsibleTypes (state:ProblemReportState, responsibleTypes:ProblemResponibleType[]) {
    state.responsibleTypeOptions = responsibleTypes.map((responsibleType: ProblemResponibleType) => {
      return {
        value: responsibleType.Problem_Responsible_Type_ID,
        label: responsibleType.Problem_Responsible_Type_Description,
        selected: false
      }
    })
  },
  setProblemReportMeasures (state:ProblemReportState, measures:ProblemReportMeasure[]) {
    state.measureOptions = measures.map((measure: ProblemReportMeasure) => {
      return {
        value: measure.Problem_Report_Measure_ID,
        label: measure.Problem_Report_Measure_Name,
        selected: false
      }
    })
  },
  setProblemTypes (state:ProblemReportState, problemTypes:ProblemType[]) {
    state.problemTypeOptions = problemTypes.map((problemType: ProblemType) => {
      return {
        value: problemType.Problem_Type_ID,
        label: problemType.Problem_Type_Description,
        selected: false
      }
    })
  },
  setResponsibleProviders (state:ProblemReportState, responsibleProviders:ResponsibleProvider[]) {
    state.responsibleProvidersOptions = []
    for (let i = 0; i < responsibleProviders.length; i++) {
      const provider = responsibleProviders[i]
      if (provider.Problem_Responsible_Name !== 'N/A') {
        state.responsibleProvidersOptions.push({
          value: provider.Problem_Responsible_ID,
          label: provider.Problem_Responsible_Name,
          selected: false
        })
      }
    }
  },
  setLoadedProblemReports (state:ProblemReportState, loadedProblemReports:any[]) {
    state.loadedProblemReports = map(loadedProblemReports, (problemReport) => {
      if (problemReport.Problem_Report_Measure) {
        problemReport.Problem_Report_Measure_ID = problemReport.Problem_Report_Measure.Problem_Report_Measure_ID
        problemReport.Problem_Report_Measure_Name = problemReport.Problem_Report_Measure.Problem_Report_Measure_Name
      }
      delete problemReport.Problem_Report_Measure
      return problemReport
    })
  },
  setMeasureFilter (state:ProblemReportState, measureFilter:ProblemReportFilter) {
    Vue.set(state, 'measureFilter', measureFilter)
  },
  reset (state:ProblemReportState) {
    state.responsibleTypeOptions = []
    state.problemTypeOptions = []
    state.responsibleProvidersOptions = []
    state.loadedProblemReports = []
    state.measureOptions = []
    state.measureFilter = null
  }
}
const actions = <ActionTree<ProblemReportState, any>>{
  loadProblemReportMeasures (store: ActionContext<ProblemReportState, any>): Promise<any> {
    return store.dispatch('user/hasPermission', { permissionType: constants.PERMISSION_TYPES.PROBLEM_REPORT_MEASURE, permissionValue: constants.PERMISSION_VALUES.LIST }, { root: true })
      .then((hasPermission):any => {
        if (!hasPermission) {
          return Promise.resolve('not needed')
        } else {
          return webApi.problem_report.getProblemReportMeasures()
            .then((response) => {
              store.commit('setProblemReportMeasures', response.data)
              return Promise.resolve('success')
            }).catch((response) => {
              window.bus.$emit('openErrorModal', 'error loading available problem Report Measures: ' + response.ExceptionMessage)
              return Promise.reject(response)
            })
        }
      })
  },
  loadResponsibleTypeList (store: ActionContext<ProblemReportState, any>): Promise<any> {
    return store.dispatch('user/hasPermission', { permissionType: constants.PERMISSION_TYPES.PROBLEM_REPORT, permissionValue: constants.PERMISSION_VALUES.CREATE }, { root: true })
      .then((hasPermission):any => {
        if (!hasPermission) {
          return Promise.resolve('not needed')
        } else {
          return webApi.problem_report.get_Problem_Responsible_Type_List()
            .then((response) => {
              store.commit('setResponsibleTypes', response.data)
              return Promise.resolve('success')
            }).catch((response) => {
              window.bus.$emit('openErrorModal', 'error loading problem responsible types: ' + response.ExceptionMessage)
              return Promise.reject(response)
            })
        }
      })
  },
  loadProblemTypeList (store: ActionContext<ProblemReportState, any>, problemResponsibleType:number): Promise<any> {
    return webApi.problem_report.get_Problem_Type_List(problemResponsibleType)
      .then((response) => {
        store.commit('setProblemTypes', response.data)
        return Promise.resolve('success')
      }).catch((response) => {
        window.bus.$emit('openErrorModal', 'error loading problem types: ' + response.ExceptionMessage)
        return Promise.reject(response)
      })
  },
  loadResponsibleProviders (store: ActionContext<ProblemReportState, any>, problemResponsibleType:number): Promise<any> {
    return webApi.problem_report.get_Problem_Responsible_List(problemResponsibleType)
      .then((response) => {
        store.commit('setResponsibleProviders', response.data)
        return Promise.resolve('success')
      }).catch((response) => {
        window.bus.$emit('openErrorModal', 'error loading problem types: ' + response.ExceptionMessage)
        return Promise.reject(response)
      })
  },
  loadProblemReports (store: ActionContext<ProblemReportState, any>): Promise<any> {
    if (!store.state.measureFilter) {
      return Promise.reject(new Error('no measure filter active'))
    }
    return webApi.problem_report.getProblemReportsWithMeasures(store.state.measureFilter)
      .then((response) => {
        store.commit('setLoadedProblemReports', response.data)
        return Promise.resolve('success')
      }).catch((response) => {
        window.bus.$emit('openErrorModal', 'error loading problem types: ' + response.ExceptionMessage)
        return Promise.reject(response)
      })
  },
  updateProblemReportsWithMeasures (store: ActionContext<ProblemReportState, any>, measure:SetProblemReportMeasure): Promise<any> {
    return webApi.problem_report.updateProblemReportsWithMeasures(measure).then((response) => {
      store.dispatch('loadProblemReports')
      return Promise.resolve('success')
    }).catch((response) => {
      window.bus.$emit('openErrorModal', 'error setting measure: ' + response.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  setMeasureFilter (store: ActionContext<ProblemReportState, any>, filter:any): void {
    store.commit('setMeasureFilter', filter)
  },
  reset (store: ActionContext<ProblemReportState, any>):void {
    store.commit('reset')
  }

}
const getters = <GetterTree<ProblemReportState, any>> {
  getMeasureFilter: (state: ProblemReportState):ProblemReportFilter => {
    return state.measureFilter
  }
}
export default ({
  namespaced: true,
  state: new ProblemReportState(),
  mutations,
  actions,
  getters
})
